import React, { useState } from 'react';
import Input from '../components/ui/Input';

const fields = ['name', 'language', 'project', 'concept'];

const Assistant = () => {
    const [formData, setFormData] = useState({});
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleChange = (e) => {
    const id = e.target.id;
    const value = e.target.value;
        setFormData((prevData) => ({ ...prevData, [id]: value }));
    };

    const generateNote = async () => {
        setLoading(true);

        fetch("https://api.openai.com/v1/chat/completions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
            },
            body: JSON.stringify({
                model: "gpt-3.5-turbo",
                messages: [
                    {
                        "role": "system",
                        "content": "you are a professional coding tutor for kids. after each session you need to write a brief and casual note to the parents of the student that informs them of student progress throughout the session. do not be too formal saying words like dear to the parents. keep it brief and casual while focusing on the actual relevant information. the signal to noise ratio should be as high as possible."
                    },
                    {
                        "role": "user",
                        "content": `Write a note for ${formData.name}. Write about ${formData.concept} in depth for each concept to the parent. The language is ${formData.language}. Make sure to include relevant details about the language when describing concepts. The project they are currently working on is ${formData.project}. If you know of similar projects in ${formData.language} add info about those as well. End off the note with a simple message as well as descriptive homework for the student to work on between now and next week to best prepare them for the next session. The coaches name to sign the note off with is ${localStorage.getItem('user')}.`
                    },
                ],
            })
        })
        .then((response) => response.json())
        .then((result) => setNote(result.choices[0].message.content))
        .then(() => navigator.clipboard.writeText(note))
        .then(() => setCopied(true))
        .catch((error) => console.log("error", error))
        .finally(() => setLoading(false));
    };

    return (
        <div className="flex flex-col justify-center items-center gap-4 p-6">
            <h1 className="text-xl font-bold dark:text-white">Note Writing Assistant</h1>
            {fields.map(field => <Input
                key={field}
                id={field}
                thing={field}
                value={formData[field] || ''}
                onChange={handleChange} />
            )}
            {loading ? <p className="text-md dark:text-white">Generating your note..... (this may take a minute!)</p>
            :
            <button
                className="whitespace-nowrap w-30 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline dark:bg-gray-600 dark:hover:bg-gray-700"
                onClick={generateNote}>
                Generate Note
            </button>}
            <p className="text-lg sm:w-1/3 dark:text-white">{note}</p>
            {copied && <p className="text-2xl text-green-600 dark:text-green-300">Note copied to clipboard!</p>}
        </div>
    );
};

export default Assistant;
